import axios from "axios";
import * as qs from "qs";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.paramsSerializer = function (params) {
  const result = qs.stringify(params, { indices: false }); // param=value1&param=value2
  return result;
};

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    // toast.error("An unexpected error occured.");
  }
  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
